import NavigationLayout from '../navigation/navigationLayout';
import FooterLayout from '../footer/footerLayout';
import { Box, Grid, Stack, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ButtonComponent from '../../components/form/buttonComponent';
import { useNavigate } from 'react-router-dom';

const InvalidPage = () => {
    const theme = useTheme();
    const {t} = useTranslation();

    const navigate = useNavigate();

    return (
        <>
            <NavigationLayout />

            <Stack
                position='relative'
                direction='column'
                justifyContent='center'
                alignItems='center'
                width='100%'
                className="navigationSpace"
            >
                {/* Upper cloud */}
                <Box
                    sx={{
                        width: '100%',
                        zIndex: 1,
                        backgroundColor: theme.palette.primary.main
                    }}
                >
                    <img 
                        src='/images/vectors/wave bg 2.png' 
                        alt='cloud' 
                        width='100%' 
                        style={{
                            transform: 'translateY(6px)'
                        }}
                    />
                </Box>

                <Grid
                    direction='row'
                    justifyContent='center'
                    alignItems='center'
                    container
                    sx={{
                        backgroundColor: 'white',
                        py: {xs: 5, md: 10}
                    }}
                    width='100%'
                    className="bodyPadding"
                    spacing={{xs: 2, md: 2}}
                >
                    <Grid size={{xs: 12, md: 5}}>
                        <Box
                            sx={{
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'center'
                            }}
                        >
                            <img 
                                src="/images/game/Penguin.gif" 
                                alt="Character" 
                                width='50%'
                                data-aos="zoom-out-up"
                                data-aos-easing="ease-out-back"
                                data-aos-delay="300"
                                data-aos-duration="1000"
                            />
                        </Box>
                    </Grid>

                    <Grid size={{xs: 12, md: 7}}>
                        <Stack
                            direction='column'
                            justifyContent='center'
                            alignItems='center'
                            spacing={2}
                        >
                            <Typography
                                sx={{
                                    fontWeight: 700,
                                    fontSize: {xs: 45, md: 60, lg: 75},
                                    color: theme.palette.primary.main,
                                    lineHeight: 1.15,
                                    textAlign: {xs: 'center', md: 'left'}
                                }}
                                data-aos="fade-up"
                                data-aos-duration="1000"
                            >
                                {t('notFound.title')}
                            </Typography>

                            <Typography
                                sx={{
                                    fontWeight: 400,
                                    fontSize: {xs: 12, md: 14, lg: 16},
                                    textAlign: {xs: 'center', md: 'left'},
                                }}
                                data-aos="fade-up"
                                data-aos-delay="100"
                                data-aos-duration="1000"
                            >
                                {t('notFound.description')}
                            </Typography>

                            <Stack
                                direction='row'
                                justifyContent={{xs: 'center', md: 'start'}}
                                width='100%'
                                data-aos="fade-up"
                                data-aos-delay="200"
                                data-aos-duration="1000"
                            >
                                <ButtonComponent 
                                    label={t('notFound.home')}
                                    onClick={() => {
                                        navigate('/');
                                    }}
                                />
                            </Stack>
                        </Stack>
                    </Grid>
                </Grid>
            </Stack>

            <FooterLayout />
        </>
    );
}

export default InvalidPage;